export enum MarketSegment {
  CORP = 'CORP',
  FIG = 'FIG',
  SSA = 'SSA',
}
